/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';

import { FiraSansBold, FontWeight, Text } from '../Text';
import { Breakpoints } from "../../constants/Breakpoints";
import { mediaHelper } from "../../utils/src";
import { Field } from 'formik'

export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.GREEN};
  margin: 0;
  border-radius: 10px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px;
`;

export const RowFilterSearch = styled.div`
  background-color: ${Colors.GREEN};
  border-radius: 10px 10px 0 0;
  margin-bottom: 10px;
  padding: 7px 0;
  
  > div:first-child {
    display: block;
  }
  
  ${mediaHelper.sm`
    border-radius: 15px 15px 0 0;
  `}
  
  @media screen and (min-width: ${Breakpoints.md}) {
    background-color: ${Colors.GREEN} !important;
    border-radius: 20px 20px 0 0;
    margin-bottom: unset;
      
    &.header-filter {
      display: none;
    }

    > div:first-child {
      display: flex ;
    }
  }
`;

export const RowFilterOrder = styled.div`
  border-radius: 10px 10px 0 0;
  display: flex;
  width: 95%;

  @media screen and (min-width: ${Breakpoints.md}) {
    margin-bottom: 10px;
    border-radius: unset;
    
   };
   @media screen and (min-width: ${Breakpoints.xxs}) and (max-width: 767px){
    display: flex;
    flex-direction: column;

   }
  
`

export const BtnLoad = styled(Text)`
  color: ${Colors.GRAY[1]};
  cursor: pointer;
  font-weight: ${FontWeight.SemiBold};
  font-size: 15px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.PINK};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const ContentTextarea = styled.div`
  width: 100%;  
  margin: 20px 10px;
  p{
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px;
  }
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;
  position: absolute;
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 5px 0;
    background-color: ${Colors.GRAY[4]};
`;

export const CustomField = styled.div`
  display: flex;
  min-width: 60%;
  vertical-align: middle;
  width: 100%;
  flex-wrap: wrap;

  > div {
    width: 100%;
    font-size: 12px;
  }
  
  @media screen and (max-width: ${Breakpoints.sm}) {
      margin-bottom: 2px;
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  
  i {
    width: 20px;
    height: 20px;  
  }
  
  i:first-child {
    margin-right: 10px;
  }
  
  i:before {
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
  }
`;

export const MobileContainer = styled.div`
  &.filter-open {
    display: block;
    position: fixed;
    overflow-x: scroll;
    top: 0;
    height: 100%;
    left: 0;
    width: 100%;
    background-color: ${Colors.WHITE};
    z-index: 2000;
    padding: 1rem 2rem;

    
    > div > div {
      background-color: ${Colors.WHITE};
      
    }
  }
  
  &.filter-close {
    display: none;
  }
  
  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px 15px;
    font-size: 30px;
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    &.filter-open {
      display: inline-block;
      position: unset;
      overflow-x: unset;
      top: unset;
      height: unset;
      left: unset;
      width: unset;
      background-color: revert;
      z-index: unset;
      padding: unset;
      
    }
    &.filter-close {
      display: unset;
    }
    .icon-close {
      display: none;
    }
  }
`;

export const MobileFilterOrder = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column-reverse;
  
  
  > div:first-child > div {
    text-align: center;
  }
  
  hr {
    width: 100%;
    border: 1px solid ${Colors.GRAY[3]};
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: block;

    hr {
      display: none;
    }
   
    > div.apply-button-container {
      display: none;
    }
  }
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};




  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;

    
  }
`;

export const ColGrid = styled.div`
position: relative;
width: 100%;
height: 40px;
display: flex; 

@media screen and (min-width: ${Breakpoints.xxs}) and (max-width: 767px){
  display: block;
  margin-bottom: 10px;
}
`

export const RowGrid = styled.div`
width: 100%;
height: 60px;
display: flex;
align-items: center;
justify-items: center;
padding: 0 10px;

@media screen and (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.md}){
  display: block;
  height: 100%;
  padding-left: 0px; 

}

@media screen and (min-width: ${Breakpoints.md}){
  height: 100%;
  display: flex;
  align-items: center;
}

`

export const FieldGrid = styled(Field)`
width: 90%;
height: 10px;
border-radius: 4px;
padding-left: 5px;
vertical-align: middle;
`

export const ColIcon = styled.div`
  display: flex;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;

  @media screen and (min-width: ${Breakpoints.xxs}) and (max-width: 767px) {
    display: none;
  }
`

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
  max-width: 100%;  
  min-width: 100%;
  table-layout: fixed;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableBody = styled.tbody`
  tr {
    border-bottom: 2px solid #E0E0E0;
  }
`

export const TableColumn = styled.td`
  vertical-align: top;
  text-align: left;
  padding-bottom: 15px;
  padding-top: 15px;
  padding-right: 15px;
  display: table-cell;

  &:last-child {
   padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }

    text-align: left;
  }
`

export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}%` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}%` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ paddingRight }) => paddingRight ? `padding-right: ${paddingRight}px` : ''}
  text-align: left !important;
  span {
    font-size: 16px !important;
  }
  &:last-child {
    ${({notLastColumnAlign}) => !notLastColumnAlign && 'text-align: right'};
  }
`

export const TableRow = styled.tr`  
`

export const DialogIcon = styled.div`
    height: 30px;
    display: inline;
    margin-right: 5px;
    width: 100%;
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
  }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;










